// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__8oIS5","options":"AnswerScale_options__wajCO","selected":"AnswerScale_selected__2LNY_"};